// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1Dcs5","cardHeader":"card-module--card-header--yoDGb","cardContent":"card-module--card-content--2FkYp","cardFooter":"card-module--card-footer--rDWt5"};